import { Row } from 'farmhub-ui-core';
import styled, { css } from 'styled-components';

export const CButton = styled.button<{ height: number }>`
  width: 100%;
  height: ${props => props.height}px;
  background: ${props => `${props.theme.colors.primary.main}12`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  border: none;
  padding: 0px 12px;
  font-weight: ${props => props.theme.font.weight.extraBold};
  color: ${props => props.theme.colors.text.primary};
  cursor: pointer;
  .text {
    color: ${props => props.theme.colors.primary.main};
  }

  .icon {
    color: ${props => props.theme.colors.text.primary};
  }

  &:hover {
    background: ${props => `${props.theme.colors.primary.main}10`};

    .text {
      color: ${props => props.theme.colors.primary.main};
    }
    .icon {
      color: ${props => props.theme.colors.primary.main};
    }
  }

  position: relative;
`;

export const CButtonBack = styled.button`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 24px;
  top: 10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f5f5f5;
  border: none;
  &:hover {
    .icon {
      color: ${props => props.theme.colors.primary.main};
    }
  }
  cursor: pointer;
`;

export const SpaceStyles = css`
  .text {
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${props => props.theme.font.size.xs};
    font-weight: ${props => props.theme.font.weight.medium};
  }
  position: relative;
`;

export const InfoCartWrapper = styled(Row)`
  img {
    width: 32px;
    height: 32px;
  }

  svg:first-child {
    width: 12px;
    height: 12px;
  }
`;

export const ContentWrapper = styled(Row)`
  font-weight: ${p => p.theme.font.weight.regular};
  text-align: start;
`;

export const WrapperText = styled.div`
  width: 240px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 18px;
  cursor: pointer;
`;

export const DomainWrapper = styled(Row)`
  .check-out-line {
    svg {
      fill: ${p => p.theme.colors.success};
    }
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;
